import { render, staticRenderFns } from "./Duyurular.vue?vue&type=template&id=1301c272&scoped=true&"
import script from "./Duyurular.vue?vue&type=script&lang=js&"
export * from "./Duyurular.vue?vue&type=script&lang=js&"
import style0 from "./Duyurular.vue?vue&type=style&index=0&id=1301c272&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1301c272",
  null
  
)

export default component.exports